import { KdsSwitch, KdsText } from "@kazaar-platform/design-system";
import { type ReactNode } from "react";

interface Props {
  isSelected: boolean;
  onChange?: (isSelected: boolean) => void;
  title?: string;
  description: string;
  withMetadata: boolean;
  metadataComponent?: ReactNode;
}

export const SwitchGroup = ({
  onChange,
  isSelected = false,
  title,
  description,
  withMetadata = false,
  metadataComponent,
}: Props) => {
  return (
    <div className="inline-flex w-full items-start justify-start gap-4 rounded-2xl border border-slate-200 bg-white p-6">
      <div className="relative h-6 rounded-[100px] bg-slate-300">
        <KdsSwitch size="small" isSelected={isSelected} onChange={onChange} />
      </div>

      <div className="flex shrink grow flex-col gap-4">
        <div className="flex shrink grow flex-col gap-1">
          <KdsText size="subtitle-sm">{title}</KdsText>
          <KdsText>{description}</KdsText>
        </div>

        {withMetadata && (
          <div className="border-t border-slate-200 pt-4">
            {metadataComponent}
          </div>
        )}
      </div>
    </div>
  );
};
